import React from "react";
import whyImg from "../assets/img/weserve.png";
import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import logo from "../assets/img/nigerchinlogo.png";

const products = [
  {
    id: 1,
    heading: "Copper Surface & Conduit Wiring Cable",
  },
  {
    id: 2,
    heading: "Copper Multi-core Control Cable",
  },
  {
    id: 3,
    heading: "Copper/Aluminium Single Core Mains Cable",
  },
  {
    id: 4,
    heading: "Copper/Aluminium Multi-core Cable",
  },
  {
    id: 5,
    heading: " Aluminium Service Entrance Cable",
  },
  {
    id: 6,
    heading: "Aluminium Bare Overhead Conductor (AAC)",
  },
  {
    id: 7,
    heading: "Aluminium Conductor Steel Reinforced (ACSR)",
  },
  {
    id: 8,
    heading: "Airfield Lighting Cable",
  },
  {
    id: 9,
    heading: "Fire Resistant Cable",
  },
  {
    id: 10,
    heading: "Special Cables",
  },
];

function ProductRanges() {
  return (
    <div className="md:mt-10 mt-1 mb-8 pt-10 pb-1 md:mx-12 mx-7">
      <h2 className="font-bold text-xl md:text-3xl mt-5 md:mt-0 text-center md:mb-7">
        Nigerchin Product Ranges
      </h2>
      <div className="block md:grid md:grid-cols-2">
        <div className="mt-6">
          <img src={whyImg} alt="" className="w-[80%] rounded-xl" />
        </div>
        {/* <div className="bg-black py-2 px-3 absolute right-5 rounded md:right-[55vw] mt-[-32vh] md:mt-[10vh]">
          <img src={logo} className="w-[6rem] md:w-[8rem] rounded" alt="" />
        </div> */}
        <div>
          <p className="text-gray-600 mt-6">
            We offer an extensive selection of electrical wires, cables, and
            conductors built to international and custom specifications,
            including:
          </p>
          <ul className="mt-8 md:w-[80%] w-[100%] gap-y-6 grid grid-cols-1 md:grid-cols-2 gap-x-5">
            {products?.map((item) => (
              <motion.li
                key={item?.id}
                initial={{
                  translateY: -100,
                  opacity: 0,
                }}
                whileInView={{
                  translateY: 0,
                  opacity: 1,
                }}
                transition={{
                  duration: 1,
                }}
              >
                <h3 className="font-semibold flex gap-2 items-center">
                  <FaCheckCircle className="text-primary" /> {item?.heading}
                </h3>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ProductRanges;
